// TICKET-01515: some clinics want invoicing (faktura) to be an admin-only
// action. With featureFlags.invoiceAdminOnly = 1 only a clinic admin (or a
// system admin) may turn a sale into an invoice; everyone else still takes
// payment or leaves the visit "pågående". Off by default. Mirrored by
// backend/lib/invoice-permissions.js, which enforces the same rule on PATCH —
// this helper only decides what the UI shows.

export function isInvoiceAdminOnly(featureFlags = {}) {
    return parseInt(featureFlags?.invoiceAdminOnly, 10) === 1;
}

export function canCreateInvoice({ isAdmin = false, isCustomerAdmin = false, featureFlags = {} } = {}) {
    if (!isInvoiceAdminOnly(featureFlags)) {
        return true;
    }
    return !!(isAdmin || isCustomerAdmin);
}
